import { FC, useContext } from "react";
import { Modal } from "@app/shared/Modals";
import { ExceptionsFiltersContext } from "./contexts/ExceptionsFiltersContext";

interface BulkEditConfirmationModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  handleConfirm: () => void;
}

const BulkEditConfirmationModal: FC<BulkEditConfirmationModalProps> = ({ isModalOpen, setIsModalOpen, handleConfirm }) => {

  const exceptionFilterContext = useContext(ExceptionsFiltersContext);

  const closeModal = () => {
    setIsModalOpen(false);
  }

  return (
    <Modal
      closeModal={closeModal}
      content={{
        body: (
          <div className="pl-3 pr-3 mb-3">
            {`Updates will be made to ${exceptionFilterContext.selectedExceptionIds.length} exception${exceptionFilterContext.selectedExceptionIds.length == 1 ? "" : "s"}. Do you wish to continue?`}
          </div>
        ),
        cancelButtonText: "Cancel",
        confirmButtonAction: handleConfirm,
        confirmButtonText: "Continue",
        confirmButtonType: "primary",
        title: "Exception Edit"
      }}
      isVisible={isModalOpen}
      hideBodyScroll={true}
    />
  );
}

export default BulkEditConfirmationModal;
